// This file was automatically generated from ptdata.smokingStatuses.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.smokingStatuses');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.smokingStatuses.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.smokingStatus), (opt_data.asOfDate) ? ' (as of: ' + (soy.$$escapeHtml(opt_data.asOfDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.asOfDate)) : '') + ')' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.smokingStatuses.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.smokingStatuses.summary(opt_data, output);
  output.append((opt_data.isNoChange) ? ' (no change)' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.smokingStatuses.dialogSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Current smoking status: ', (opt_data.smokingStatus) ? soy.$$escapeHtml(opt_data.smokingStatus) + ((opt_data.asOfDate) ? ' (as of ' + (soy.$$escapeHtml(opt_data.asOfDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.asOfDate)) : '') + ')' : '') : 'have not asked before');
  if (!opt_sb) return output.toString();
};
